import React from 'react';

const BookingsManagement = () => {
  return (
    <div className="bookings-management-container">
      <h1>Bookings Management</h1>
      <p>This is the Bookings Management page. Content will be updated soon.</p>
    </div>
  );
};

export default BookingsManagement; 